import React from 'react'
import {UserContext} from '../../context/User'
import {AuditPaneContext} from '../../context/AuditPane'
import AuditAdminMenu from '../AuditAdminMenu'
import {AuditContext} from '../../context/Audits'
import {TemplatesContext} from '../../context/Templates'
import GroupTabs from '../AuditDetailTab/GroupTabs'
import TableTabs from './TableTabs'
import TableAudits from './TableAudits'
import Header from './Header'
import Users from './Users'
import Details from './Details'
import {data} from 'jquery'

function AuditExpanded({itemId, id}) {
  const {audit} = React.useContext(AuditContext)
  const {template} = React.useContext(TemplatesContext)

  const user = React.useContext(UserContext)
  const paneState = React.useContext(AuditPaneContext)

  const permission = (user.details && user.details.canCreate) || false
  const isTemplate = (paneState.activeTab === 'audit' ? false : true) || false

  const selected = (isTemplate ? template && template.selected : audit && audit.selected) || null

  const handleCloseExpand = () => {
    paneState.resetDefault()
    if (itemId || id) {
      window.open(`${process.env.REACT_APP_ROOT_API_URL}/audits`, '_top')
    }
  }
  return (
    paneState.isExpandOpen &&
    selected && (
      <div className="audit-expand">
        <section className="audit-expand__section">
          <Header data={selected} isTemplate={isTemplate} />
          {permission && (selected.audit_type_for_user === 'created' || user.details.is_admin) && (
            <AuditAdminMenu cross data={selected} />
          )}
          <div className="action-back">
            <div
              className="audit-icon--close audit-icon--16 audit-icon--black cursor_pointer ml_8"
              tabIndex="0"
              onClick={() => handleCloseExpand()}
            ></div>
          </div>
        </section>
        <section className="audit-expand__section audit-expand__section--details mt_15">
          <div className="row w-100">
            <div className="col-md-4">
              <Details data={selected} isTemplate={isTemplate} permission={permission} />
            </div>
            <div className="col-md-6 pr-0">
              <GroupTabs data={selected.audit_entities_attributes} />
            </div>
          </div>
        </section>
        <section className="audit-expand__section table-tabs mt-50">
          {isTemplate ? (
            <TableAudits currentTemplate={selected} />
          ) : (
            <TableTabs data={selected} itemId={itemId} />
          )}
        </section>
      </div>
    )
  )
}

export default AuditExpanded
